type ProductTypes = {
  name: string
  link: string
  image: string
}
export const productTypes: ProductTypes[] = [
  {
    name: 'homepage.products.new-wardrobe',
    link: '/configurator/wardrobe-new-collection',
    image: '/cdn/renders-landing/new-wardrobe.jpg',
  },
  {
    name: 'homepage.products.wardrobe',
    link: '/configurator/wardrobe',
    image: '/cdn/renders-landing/wardrobe.png',
  },
  {
    name: 'homepage.products.stand',
    link: '/configurator/stand',
    image: '/cdn/renders-landing/stand.png',
  },
  {
    name: 'homepage.products.TVstand',
    link: '/configurator/tv-stand',
    image: '/cdn/renders-landing/tv-stand.png',
  },
  {
    name: 'homepage.products.bedside',
    link: '/configurator/bedside',
    image: '/cdn/renders-landing/bedside.png',
  },
  {
    name: 'homepage.products.rack',
    link: '/configurator/rack',
    image: '/cdn/renders-landing/rack.png',
  },
  {
    name: 'homepage.products.work-table',
    link: '/configurator/work-table',
    image: '/cdn/work-table/work-table.jpg',
  },
  {
    name: 'homepage.products.showRack',
    link: '/configurator/show-rack',
    image: '/cdn/renders-landing/show-rack.png',
  },
]
